import httpClient from '@shared/http/client';
import { clearResponseCache } from './cache';

export const deleteSource = (url) =>
  new Promise(async resolve => {
    try {
      const response = await httpClient.delete(url);
      clearResponseCache(url);
      resolve(response.data);
    } catch (err) {
      console.log(err);
      resolve(new Error(err.message));
    }
  });
